<template>
  <BjDrawerForm
    ref="BjDrawerForm"
    :form="form"
    :rules="rules"
    label-width="120px"
    @handleConfirm="handleConfirm"
  >
    <BjDivider>基本信息</BjDivider>
    <el-col :span="24">
      <el-form-item label="名称" prop="tenantName">
        <BjInput
          v-model="form.tenantName"
          :maxlength="MAX_LENGTH.DEFAULT"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <BjFormItemCode
        v-model="form.tenantNum"
        label="编码"
        prop="tenantNum"
        required
        :disabled="isEdit"
      />
    </el-col>
    <el-col :span="24">
      <el-form-item label="限制用户数" prop="limitUserQty">
        <BjInputNumber
          v-model="form.limitUserQty"
          placeholder="请输入"
          clearable
          not-auto-zero
          :min="0"
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="有效期起" prop="startDateActive">
        <el-date-picker
          v-model="form.startDateActive"
          class="full-width"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择"
          @change="handleChangeStartTime"
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="有效期至" prop="endDateActive">
        <el-date-picker
          v-model="form.endDateActive"
          class="full-width"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择"
          :picker-options="$disabledPickerDate(form.startDateActive)"
        />
      </el-form-item>
    </el-col>
    <el-col :span="24">
      <el-form-item label="启用" prop="enabledFlag">
        <el-switch v-model="form.enabledFlag" :active-value="1" :inactive-value="0" />
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { tenantApi } from '@/api';

const getDefaultForm = () => {
  return {
    tenantNum: '',
    tenantName: '',
    limitUserQty: '',
    enabledFlag: 1,
    startDateActive: null,
    endDateActive: null,
  };
};

export default {
  name: 'SysOrganizationMaintainComponentsDataForm',
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        tenantName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        tenantNum: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        limitUserQty: [{ required: false, message: '请输入限制用户数', trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    show(info) {
      this.isEdit = !!(info && info.tenantName);
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? '编辑' : '新建');
      this.form = Object.assign(getDefaultForm(), info || {});
    },
    handleChangeStartTime(startTime) {
      const { startDateActive, endDateActive } = this.form;
      if (new Date(endDateActive) < new Date(startDateActive)) {
        this.form.endDateActive = null;
      }
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        delete API_DATA.id;
        this.updateApi({
          tenantNum: API_DATA.tenantNum,
          tenantName: API_DATA.tenantName,
          limitUserQty: API_DATA.limitUserQty,
          enabledFlag: API_DATA.enabledFlag,
          startDateActive: API_DATA.startDateActive,
          endDateActive: API_DATA.endDateActive,
          objectVersionNumber: API_DATA.objectVersionNumber,
          _token: API_DATA._token,
          tenantId: API_DATA.tenantId,
          organizationId: API_DATA.tenantId,
        });
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },

    addApi(API_DATA) {
      tenantApi.addTenants(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success('保存成功');
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      tenantApi.updateTenants(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success('保存成功');
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
